module.exports = __webpack_public_path__ + "img/f1f2f06.jpg";